import "../../scss/layout/layout.scss";
import "../common/InteropHelper";
//up is layout
import "../../scss/pages/mapIndex.scss";
import "../../scss/pages/about.scss";
import "../../scss/pages/feedback.scss";


import "../interopCore";

import "../components/captcha";


(<any>window).initApp = () => {
    window.VGIS.vMap.init("map");
}

